export default __webpack_public_path__ + "link-icons.svg";